import { keys } from "i18n/keys";
import { RYC_FEATURE_FLAGS } from "@/features/relayYardControl/config/rycFeatureFlagKeys";
import { RYTE_FEATURE_FLAGS } from "@/features/ryteTracker/config/ryteFeatureFlagKeys";

export const ROOT_URLS = {
  USAmazon: {
    test: "https://trans-logistics.integ.amazon.com",
    master: "https://preprod-trans-logistics.amazon.com",
    prod: "https://trans-logistics.amazon.com",
  },
  EUAmazon: {
    master: "https://preprod-trans-logistics-eu.amazon.com",
    prod: "https://trans-logistics-eu.amazon.com",
  },
  JPAmazon: {
    master: "https://preprod-trans-logistics-fe.amazon.com",
    prod: "https://trans-logistics-fe.amazon.com",
  },
};

export const AMAZON_BUILDING_CODE = "Amazon";

export const PAGE_NAME = {
  RYC: "Yard Control",
  EQUIPMENT: "Equipment",
  APPOINTMENTS: "Appointments",
  YARD_DESIGNER: "Yard Designer",
  YARD_DASHBOARD: "Yard Dashboard",
  EVENT_HISTORY_REPORT: "Event History Report",
  REMOTE_GATE: "Remote Gate",
  RELAY_TRACK_TRACE: "Track & Trace",
  LABOUR_TRACKING: "Labour Tracking",
  RELAY_YARD_TRACKER: "Yard Tracker",
  RYTE_TRACKER: "Auto Dock",
  OWNER_CONFIGURATION: "Owner Configuration",
  HOSTLER_POOL: "Hostler Pool",
  AGENT_STUDIO: "Agent Studio",
};

export const FEATURE_FLAGS = {
  SHOW_WRANGLING_REPORT: "showWranglingReport",
  SHOW_EQUIPMENT_REPORT: "showEquipmentReport",
  ENABLE_RYT: "enableRYT",
  ENABLE_DRIVER_VISIT_TAB: "enableDriverVisitTab",
  ENABLE_YARD_DOMAIN_EVENTS_TAB: "enableYardDomainEventsTab",
  ENABLE_EVENT_HISTORY_TIMELINE: "enableEventHistoryTimeline",
  ENABLE_EVENT_HISTORY_NAVIGATION: "enableEventHistoryNavigation",
  ENABLE_OWNER_CONFIGURATION: "enableOwnerConfiguration",
  ENABLE_EQUIPMENT_EDIT: "enableEquipmentEdit",
  ENABLE_EQUIPMENT_TAB: "enableEquipmentTab",
  ENABLE_EQUIPMENT_ACTION_PANEL: "enableEquipmentActionPanel",
  ENABLE_REQUEST_MOVE: "enableRequestMove",
  ENABLE_REALIGNMENT_MOVE: "enableRealignmentMove",
  ENABLE_MOVE_TO_EXIT_GATE: "enableMoveToExitGate",
  ENABLE_MCI_RESOLUTION_MESSAGING: "enableMciResolutionMessaging",
  ENABLE_HOSTLER_POOL: "enableHostlerPool",
  ENABLE_AGENT_STUDIO: "enableAgentStudio",
  ENABLE_HOST_SEAM: "enableHostSeam",

  // RYC flags (co-located in feature domain)
  ...RYC_FEATURE_FLAGS,
  // RYTE flags (co-located in feature domain)
  ...RYTE_FEATURE_FLAGS,
};

// Users who should have access to all features regardless of feature flags
export const ALLOW_LIST_USERS = [
  "kelvwong",
  "jiaru",
  "janyavm",
  "wuzjw",
  "jyzwang",
  "samsiryn",
  "hyunsek",
  "ecz",
  "dgourlay",
  "pklimkow",
  "hnhn",
  "yaoboy",
  "rvvidzer",
  "dekail",
  "palimara",
  "ubemole",
  "davidtot",
  "vitdvin",
  "ikkrokus",
  "sivnithy",
  "alfoaco",
  "ntsarm",
  "plangari",
  "zyuanjie",
  "heydiana",
  "giannae",
  "cuihengy",
  "hyunsek",
  "samsiryn",
  "janyavm",
  "jiaru",
  "alferoz",
  "aganirud",
  "bkkresak",
  "fkx",
  "jonapina",
  "dccharbo",
  "idamyv",
  "davblamy",
  "allimawa",
  "antorimo",
  "bayliem",
  "chibritv",
  "dfinazzo",
  "jcalkin",
  "josconti",
  "lomaw",
  "macayf",
  "szczodro",
  "wcollazr",
  "vmedelli",
  "ashwindc",
  "ianedel",
  "alkay",
  "kayms",
  "pdeharmo",
  "amitoshd",
  "saurgoel",
  "ayushtwr",
  "hbhakuni",
  "ksy",
  "sankgup",
  "mkmohak",
  "zelialiu",
  "consmall",
  "muhamuj",
  "keithiwa",
  "mellonij",
  "emanx",
  "calstone",
  "cccarag",
  "suthotae",
  "zhaester",
  "vaasvich",
  "dgmyrick",
  "mrunmayd",
  "seakellc",
  "chmikkel",
  "tywolfe",
  "revpvs",
  "maxnbf",
];

export const TIME_TO_REFRESH_SECONDS = 5 * 60;

export const YARD360_PATHS = [keys.APPOINTMENTS, keys.EQUIPMENT];

export const PATH_TO_APP = "/relayYardHub";

export const ROUTES = {
  ROOT: `${PATH_TO_APP}/`,
  APPOINTMENTS: `${PATH_TO_APP}/appointments`,
  EQUIPMENT: `${PATH_TO_APP}/equipment`,
  RYC: `${PATH_TO_APP}/yardControl`,
  RYT: `${PATH_TO_APP}/relayYardTracker`,
  RYTE_TRACKER: `${PATH_TO_APP}/relayAutoDock`,
  OWNER_CONFIGURATION: `${PATH_TO_APP}/ownerConfiguration`,
  OWNER_CONFIGURATION_CREATE: `${PATH_TO_APP}/ownerConfiguration/create`,
  HOSTLER_POOL: `${PATH_TO_APP}/hostlerPool`,
  AGENT_STUDIO: `${PATH_TO_APP}/agentStudio`,
  HOST_SEAM: `${PATH_TO_APP}/hostSeam`,
  EVENT_REPORT: `${PATH_TO_APP}/eventHistory`,
  EVENT_REPORT_DETAIL: `${PATH_TO_APP}/eventHistory/eventReportDetail`,
};

export const YARD360_SUBPATH = {
  APPOINTMENTS: `appointments`,
  EQUIPMENT: `equipment`,
};

export const ROUTE_TO_VIEW = {
  [ROUTES.ROOT]: keys.APPOINTMENTS,
  [ROUTES.APPOINTMENTS]: keys.APPOINTMENTS,
  [ROUTES.EQUIPMENT]: keys.EQUIPMENT,
};

export const VIEW_TO_ROUTE = {
  [keys.APPOINTMENTS]: ROUTES.APPOINTMENTS,
  [keys.EQUIPMENT]: ROUTES.EQUIPMENT,
};

export const SUPPORTED_WRANGLING_VIEW_FILTERS = {
  OUTBOUND: "OUTBOUND",
  INBOUND: "INBOUND",
};

export const INITIAL_WRANGLING_VIEW_FILTER = SUPPORTED_WRANGLING_VIEW_FILTERS.OUTBOUND;

/**
 * The first 2 load types are among the possible values of wrangling.visit.loadType
 * The last 2 load types are derived from wrangling.visit.loadType instead
 */
export const SUPPORTED_LOAD_TYPES = {
  PICK_UP_EMPTY: "PICK_UP_EMPTY",
  PICK_UP_LOADED: "PICK_UP_LOADED",
  LIVE_PICK_UP: "LIVE_PICK_UP",
  LIVE_DROP_OFF: "LIVE_DROP_OFF",
};

export const WRANGLING_VIEW_SORTABLE_COLUMNS = {
  ARRIVAL_OR_DEPARTURE_TIME: "ARRIVAL_OR_DEPARTURE_TIME",
  PROGRESS: "PROGRESS",
};

export const INITIAL_WRANGLING_VIEW_SORTABLE_COLUMN =
  WRANGLING_VIEW_SORTABLE_COLUMNS.ARRIVAL_OR_DEPARTURE_TIME;

export const EQUIPMENT_VIEW_SORTABLE_COLUMNS = {
  DWELL_TIME: "DWELL_TIME",
};

export const INITIAL_EQUIPMENT_VIEW_SORTABLE_COLUMN = EQUIPMENT_VIEW_SORTABLE_COLUMNS.DWELL_TIME;

export const SUPPORTED_EQUIPMENT_EMPTY_STATUSES = {
  EMPTY: "EMPTY",
  NON_EMPTY: "NON_EMPTY",
};

export const ITEMS_PER_PAGE = 10;

export const REDIRECT_LINKS = {
  USAmazon: {
    test: {
      YARD_DESIGNER: "https://integ-trans-logistics.amazon.com/yms/yardConfig",
      YARD_DASHBOARD: "https://integ-trans-logistics.amazon.com/yms/shipclerk/#/yard",
      REMOTE_GATE: "https://integ-trans-logistics.amazon.com/yms/sesameGateConsole#/relaygate",
      RELAY_TRACK_TRACE: "https://beta.track.relay.amazon.dev",
      LABOUR_TRACKING: "",
      DOCK_MASTER: "https://prod-na.us-east-1.idx-website.aft.amazon.dev",
      TCP_BASEURL: "https://integ-trans-logistics.amazon.com",
    },
    master: {
      YARD_DESIGNER: "https://preprod-trans-logistics.amazon.com/yms/yardConfig",
      YARD_DASHBOARD: "https://preprod-trans-logistics.amazon.com/yms/shipclerk/#/yard",
      REMOTE_GATE: "https://preprod-trans-logistics.amazon.com/yms/sesameGateConsole#/relaygate",
      RELAY_TRACK_TRACE: "https://gamma.track.relay.amazon.dev",
      LABOUR_TRACKING: "",
      DOCK_MASTER: "https://prod-na.us-east-1.idx-website.aft.amazon.dev",
      TCP_BASEURL: "https://preprod-trans-logistics.amazon.com",
    },
    prod: {
      YARD_DESIGNER: "https://trans-logistics.amazon.com/yms/yardConfig",
      YARD_DASHBOARD: "https://trans-logistics.amazon.com/yms/shipclerk/#/yard",
      REMOTE_GATE: "https://trans-logistics.amazon.com/yms/sesameGateConsole#/relaygate",
      RELAY_TRACK_TRACE: "https://track.relay.amazon.dev",
      LABOUR_TRACKING: "",
      DOCK_MASTER: "https://prod-na.us-east-1.idx-website.aft.amazon.dev",
      TCP_BASEURL: "https://trans-logistics.amazon.com",
    },
  },
  EUAmazon: {
    master: {
      YARD_DESIGNER: "https://preprod-trans-logistics-eu.amazon.com/yms/yardConfig",
      YARD_DASHBOARD: "https://preprod-trans-logistics-eu.amazon.com/yms/shipclerk/#/yard",
      REMOTE_GATE: "https://preprod-trans-logistics-eu.amazon.com/yms/sesameGateConsole#/relaygate",
      RELAY_TRACK_TRACE: "https://gamma.track.relay.amazon.dev",
      LABOUR_TRACKING: "",
      DOCK_MASTER: "https://prod-eu.eu-west-1.idx-website.aft.amazon.dev",
      TCP_BASEURL: "https://preprod-trans-logistics-eu.amazon.com",
    },
    prod: {
      YARD_DESIGNER: "https://trans-logistics-eu.amazon.com/yms/yardConfig",
      YARD_DASHBOARD: "https://trans-logistics-eu.amazon.com/yms/shipclerk/#/yard",
      REMOTE_GATE: "https://trans-logistics-eu.amazon.com/yms/sesameGateConsole#/relaygate",
      RELAY_TRACK_TRACE: "https://track.relay.amazon.dev",
      LABOUR_TRACKING: "",
      DOCK_MASTER: "https://prod-eu.eu-west-1.idx-website.aft.amazon.dev",
      TCP_BASEURL: "https://trans-logistics-eu.amazon.com",
    },
  },
  JPAmazon: {
    master: {
      YARD_DESIGNER: "https://preprod-trans-logistics-fe.amazon.com/yms/yardConfig",
      YARD_DASHBOARD: "https://preprod-trans-logistics-fe.amazon.com/yms/shipclerk/#/yard",
      REMOTE_GATE: "https://preprod-trans-logistics-fe.amazon.com/yms/sesameGateConsole#/relaygate",
      RELAY_TRACK_TRACE: "https://gamma.track.relay.amazon.dev",
      LABOUR_TRACKING: "",
      DOCK_MASTER: "https://prod-jp.ap-northeast-1.idx-website.aft.amazon.dev",
      TCP_BASEURL: "https://preprod-trans-logistics-fe.amazon.com",
    },
    prod: {
      YARD_DESIGNER: "https://trans-logistics-fe.amazon.com/yms/yardConfig",
      YARD_DASHBOARD: "https://trans-logistics-fe.amazon.com/yms/shipclerk/#/yard",
      REMOTE_GATE: "",
      RELAY_TRACK_TRACE: "https://track.relay.amazon.dev",
      LABOUR_TRACKING: "",
      DOCK_MASTER: "https://prod-jp.ap-northeast-1.idx-website.aft.amazon.dev",
      TCP_BASEURL: "https://trans-logistics-fe.amazon.com",
    },
  },
};
